import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import case0 from "./components/case-0";
import case1 from "./components/case-1";
import case2 from "./components/case-2";
import case3 from "./components/case-3";
import case4 from "./components/case-4";

const principle: Slide = {
  descriptionHtml:
    "The brief requires a room for music practice with a minimum surface area of 90m<sup>2</sup>.  See below different propositions of room layout and the consequences it has on acoustic quality, space and cost.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "dropdown",
          options: {},
          items: [
            { name: "Scenario 0: First room layout proposed by architects" },
            { name: "Scenario 1: keeping the circular shape and adding internal parallel finishes" },
            { name: "Scenario 2: keeping the circular shape and adding internal but unparallel finishes" },
            { name: "Scenario 3: changing the layout for a rectangular shape" },
            { name: "Scenario 4: random shape" },
          ],
        },
      ],
      controlsPosition: "bottom",
      extraContent: [[], [], [], [], []],
      components: [case0, case1, case2, case3, case4],
    },
  },
};

export default principle;
